/** Public marketing path for the startup landing (getzephix.com). */
export const LANDING_V2_PATH = "/" as const;

export const LANDING_V2_CTA = {
  trial: "/signup",
  demoHash: "#ui-preview",
  product: "/product",
  pricing: "#pricing",
  support: "/contact",
  terms: "/terms",
  privacy: "/privacy",
  contact: "/contact",
} as const;
